module.exports = {
  UPDATE_VIEWPORT: 'OTT/viewport/UPDATE_VIEWPORT',
  SET_WEB_VIEW: 'OTT/viewport/SET_WEB_VIEW',
};
